import { Injectable } from '@angular/core';
import { EstateDetails } from '../models/estate-details';
import { Details } from '../../details/Interfaces/details';
import { nameOnly } from '@details/Interfaces/details-item-types';
import { LayoutOrientation } from '../../common/enums/layout-orientation';
import { DetailsBuilder } from '@details/Interfaces/details-builder';
import Horizontal = LayoutOrientation.Horizontal;

@Injectable()
export class EstateDetailsMapper {

  constructor() {
  }

    public map(details: EstateDetails): Details {

        const b = new DetailsBuilder(`Reference ${details.Ref}`, details);

        b.section('Estate', LayoutOrientation.Vertical)
          .always(nameOnly(details.Name))
            .for('StrungAddress', 'Address:');

        b.section('', Horizontal)
            .for('Tenure', 'Tenure is:')
            .for('Currency', 'Default currency used is:');

        return b.getDetails();
  }
}
